import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody3, TableBody4, TableBodyStk, TableBottom4, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { adminStkInwMenu, StkInwMenu, UStkInwMenu, Zones } from '../TitleList';
import { selectCommonStockReg, selectLocations, selectStkItemSize } from '../Selectors/Master/OutwardSelectors';
import { fetchCommonStockReg, fetchStockItemSize } from '../../Store/PHPSlice/stockApi';
import axios from 'axios';
import TableBottomstk from './table-bottom-stk';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import Dropdown from '../FieldsComponents/Dropdown';



const UcommonStkReg = () => {
    const dispatch = useDispatch();
    const getItems = useSelector(selectCommonStockReg);
    const allschls = useSelector(selectLocations);
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);
    const [stkdata, setStkdata] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [schlList, setSchlList] = useState([]);

    const [formData, setFormData] = useState({
        fdt: '',
        tdt: '',
        barcd: '',
        schlId: ''
    });
    useEffect(() => {
        // dispatch(fetchCommonStockReg());
        fetchSchlCommonItemStock();
        dispatch(fetchLocationData());
    }, [dispatch]);


    useEffect(() => {

        if (userdata?.pageIds?.length > 0 && userdata?.role === '2') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else if (userdata?.role === '2') {
                setActiveMenu(UStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }

            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 2);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }
    }, []);

    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setSchlList(response?.data?.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchSchlCommonItemStock = async (id) => {
        try {
            const endpoint = id ? `getCommonSchoolStkItems&schlId=${id}` : `getCommonSchoolStkItems`;
            const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
            setStkdata(response?.data?.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    if (!stkdata) {
        return <h1>Loading...</h1>;
    }
    // console.log(getItems);

    const compData = Array.isArray(stkdata) ? stkdata?.map((item, index) => (
        {
            srNo: item.ID,
            stkBarcode: item.stkBarcode,
            stkId: item.schl_stkId,
            itemId: item.itemId,
            itemNm: item.itemNm,
            size: item.size,
            qty: item.qty,
            bqty: item.bqty,
            sqty: item.sqty,
            srate: item.srate,
            disrate: item.disrate,
            disamt: item.disamt,
            // schlId: item.schlId,
            // schlcd: item.schlcd,
            // schlNm: item.schlNm,
            schlinfo: item.schlinfo,
            sts: item.sts,
            serialNumber: index + 1
        }
    )) : [];

    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };



    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);



    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totsaleqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.sqty), 0);
    const totstkqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.qty), 0);
    const totbalqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
    const totsrate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
    const totdisrate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
    const totdisamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };


    const dropdownOrdType = [
        {
            label: 'School',
            id: 'schlId',
            options: userdata?.role !== '1' ? schlList : allschls?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,

        }
    ];

    const handleSearch = (e) => {
        e.preventDefault();
        if (!formData.schlId) {
            return;
        }
        fetchSchlCommonItemStock(formData.schlId);

    };
    return (
        <>
            <Titlebar data={activeMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>School Stock Common Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>

                                </Grid>
                            </Grid>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />

                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'schlcd', label: 'School' },
                                            { id: 'itemNm', label: 'Item' },
                                            { id: 'size', label: 'size' },
                                            { id: 'qty', label: 'Stock Qty.' },
                                            { id: 'sqty', label: 'Sale Qty.' },
                                            { id: 'bqty', label: 'Bal Qty' },
                                            { id: 'srate', label: 'Sale Rate' },
                                            // { id: 'edit', label: 'Edit' },
                                            // { id: 'delete', label: 'Delete' }
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData && displayedData.length > 0 ? (
                                            <>
                                                {displayedData?.map((row) => (
                                                    <TableBodyStk
                                                        key={row.srNo}
                                                        stkBarcode={row.stkBarcode}
                                                        itemId={row.itemId}
                                                        itemNm={row.itemNm}
                                                        size={row.size}
                                                        color={row.color}
                                                        qty={row.qty}
                                                        bqty={row.bqty}
                                                        srate={row.srate}
                                                        sqty={row.sqty}
                                                        disrate={row.disrate}
                                                        disamt={row.disamt}
                                                        // schlId={row.schlId }
                                                        // schlcd={row.schlcd}
                                                        // schlNm={row.schlNm}
                                                        schlinfo={row.schlinfo}
                                                        sts={row.sts}
                                                        serialNumber={row.serialNumber}
                                                        selected={selected.indexOf(row.name) !== -1}
                                                        handleClick={(event) => handleClick(event, row.name)}
                                                    />
                                                ))}

                                                <TableBottomstk
                                                    totstkqty={totstkqty}
                                                    totsaleqty={totsaleqty}
                                                    totbalqty={totbalqty}
                                                    totdisrate={totdisrate}
                                                />
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={12} style={{ textAlign: "center", padding: "10px" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UcommonStkReg;
